export default "__VITE_ASSET__BNjqB2LJ__"